import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa"; // Make sure you have react-icons installed
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Pages
import About from "./pages/About";
import Certifications from "./pages/Certifications";
import CertificationDetail from "./pages/CertificationDetail"; 
import Blog from "./pages/Blog";
import BlogDetail from "./pages/blogData";
import Contact from "./pages/Contact";
import Home from "./pages/Home";

// Services
import ServicesAll from "./pages/Services";

import ServiceDetail from "./pages/ServiceDetail";

// ScrollToTop helper to ensure every page opens at the top (not the footer)
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant"
    });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
}

function App() {
  return (
    <>
      <ScrollToTop /> {/* Forces the view to the top whenever the route/page changes */}
      
      {/* Navbar is outside Routes so it stays visible on every page */}
      <Navbar />

      {/* Main content area with top padding to account for fixed Navbar height */}
      <main style={{ paddingTop: "85px" }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          
          {/* Service Routes */}
          <Route path="/services" element={<ServicesAll />} />
       
          <Route path="/services/:id" element={<ServiceDetail />} />
          
          {/* Certification Routes */}
          <Route path="/certifications" element={<Certifications />} />
          <Route path="/certifications/:id" element={<CertificationDetail />} />
          
          {/* Blog & Contact */}
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogDetail />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>

      {/* WhatsApp Floating Widget (Visible globally on all pages) */}
      <a
        href="https://wa.me/919867180395?text=Hello,%20I%20would%20like%20to%20know%20more%20about%20ISO%20certification%20services."
        className="whatsapp-float-btn"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
      >
        <FaWhatsapp className="whatsapp-icon" />
        <span className="whatsapp-tooltip">Chat on WhatsApp</span>
      </a>

      {/* Footer is outside Routes so it stays visible at the bottom of every page */}
      <Footer />
    </>
  );
}

export default App;